import React, { useEffect, useState } from "react";

interface CommonAlertModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  confirmText?: string;
}

const CommonAlertModal: React.FC<CommonAlertModalProps> = ({
  show,
  onClose,
  title = "Heads Up!",
  message,
  confirmText = "OK",
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      // Delay to trigger animation class
      setTimeout(() => setVisible(true), 20);
    } else {
      setVisible(false);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div
      className={`modal fade ${visible ? "show modal-fade-in" : ""} d-block`}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="commonAlertModalTitle"
      aria-hidden="true"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(4px)",
        transition: "opacity 0.3s ease",
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{
          transform: visible ? "translateY(0)" : "translateY(-20px)",
          transition: "transform 0.3s ease",
        }}
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: "#c89be0",
              color: "#ffffff",
              borderBottom: "none",
            }}
          >
            <h5
              className="modal-title"
              id="commonAlertModalTitle"
              style={{ display: "flex", alignItems: "center", gap: "8px", color: "unset" }}
            >
              <i className="fas fa-exclamation-triangle"
                style={{
                    fontSize: "22px",
                    color: "orange",
                }}
                >
              </i>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div
            className="modal-body"
            style={{
              padding: "3.5rem",
              fontSize: "1rem",
              color: "#333",
              textAlign: "center",
            }}
          >
            <p style={{ margin: 0, fontSize: "20px" }}>{message}</p>
          </div>
          <div
            className="modal-footer"
            style={{
              borderTop: "none",
              justifyContent: "center",
              paddingBottom: "1.5rem",
            }}
          >
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={onClose}
               style={{
              backgroundColor: "#c89be0",
              color: "#ffffff",
              fontSize: "17px",
              border: "unset",
            }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonAlertModal;
